<template>
    <div class="raceIntroduction">
        <div class="navbar-dark">
            <div class="container">
                <el-form
                    ref="ruleForm"
                    :rules="ruleRules"
                    :model="form"
                    :label-position="lablePosition"
                    label-width="130px"
                >
                   <el-row>
                     <el-col :span="24" style="border-bottom:1px solid #000 ">
                       <a href="../static/doc/学校批量上传操作手册.pdf"  target="_blank" style="color: #ff0000;font-size: 15px;
                        text-decoration: none;//去除a标签下划线
                        outline: none;//去掉a标签默认轮廓
                        ">批量申报操作前必看!请点击查看具体操作方法</a>
                        <el-form-item label="下载账号" style="float: left;width:100%;margin:10px 0">
                            <!-- :style="{ width: uploadStyle }" -->
                            <el-button size="small" type="primary" @click="handleAccount">点击下载</el-button>
                        </el-form-item>
                         <el-form-item label="下载报名信息" style="float: left;width:100%;margin:10px 0">
                            <!-- :style="{ width: uploadStyle }" -->
                            <el-button size="small" type="primary" @click="exportSigUpInfo">点击下载</el-button>
                            <el-radio-group v-model="radio">
                                <el-radio v-for="(item, index) in downloadWorkType" :key="index" :label="item.workValue">{{item.workTypeName}}({{item.workNum}})</el-radio>
                            </el-radio-group>
                               <!--  <el-radio v-model="radio" label="1">创意作品-智慧社区大学组(25)</el-radio>
                                <el-radio v-model="radio" label="3">创意作品-智慧社区中学组(25)</el-radio>
                                <el-radio v-model="radio" label="2">科普实验-未来太空车(25)</el-radio> -->
                        </el-form-item>
                     </el-col>
                   </el-row>
                </el-form>

            </div>
        </div>
        <el-dialog title="报名信息查看" :visible.sync="open" width="80%">
            <register-tearm-components
                :division-id="divisionId"
                :line-color="'transparent'"
                :disabled-falg="disabledFalg"
                :form="form"
                :field-name-options="fieldNameOptions"
                :dict-data-list="dictDataList"
                :site-id="queryParams.siteId"
                :field-map="fieldMap"
            ></register-tearm-components>
        </el-dialog>

        <el-dialog
            title="批量上传作品"
            :visible.sync="dialogVisible"
            width="60%"
            :close-on-click-modal="false"
            >
<!--            <el-row  style="margin:15px 0;color:black">
                <el-col :span="24" style="height:100%">
&lt;!&ndash;                  <p style="font-size:18px;color: #ff0000">
                    批量上传申报文件的操作须知：
                  </p>
                  <p>1. 为了精确识别出提交的材料对应哪个队伍，每个文件命名格式必须为：“报名编号-作品名称（或者文件类型）-序号”，除了英文格式的横线，文件命名不允许有任何符号。其中：</p>
                  <p>（1）【报名编号】为单个参赛团队的报名编号，这个编号是唯一的，并且可以从系统自行下载查看。</p>
                  <p>（2）【作品名称（或者文件类型）】每个作品提交的第一个文件，命名格式必须为“报名编号-作品名称-序号”，这是为了识别该作品的作品名称。其它的可以采用“报名编号-作品名称-序号”或者“报名编号-文件类型-序号来命名”。</p>
                  <p>（3）【序号】是为了识别不同的作品：如果同一个参赛团队，在同一个参赛项目下提交两个不同名称的作品，那么就需要通过序号区分，序号从0开始编号。</p>
                  <p style="color: #ff0000">举例如下：</p>
                  <p style="color: #ff0000">X团队（编号为11111）在创意作品-人机协作大学组提交名称为AAAAA、BBBBB的两个作品，那么需要提交的文件为：</p>
                  <table>
                    <tr>
                      <td>【1】参赛承诺和声明：</td>
                      <td>11111-AAAAA-0.pdf</td>
                      <td>11111-BBBBB-1.pdf</td>
                    </tr>
                    <tr>
                      <td>【2】项目总结报告：</td>
                      <td>11111-项目总结报告-0.pdf</td>
                      <td>11111-项目总结报告-1.pdf</td>
                    </tr>
                    <tr>
                      <td>【3】作品视频（可选）：</td>
                      <td>11111-作品视频-0.mp4</td>
                      <td>11111-作品视频-1.mp4</td>
                    </tr>
                    <tr>
                      <td>【4】证件照片：</td>
                      <td>11111-作品视频-0.zip</td>
                      <td>11111-作品视频-1.zip</td>
                    </tr>
                  </table>
                  <p>在这里，序号0就代表AAAAA作品，序号1就代表BBBBB作品。</p>
                  <p>以图片示例如下：</p><br />
                  <img src="../../static/img/sanxYL.png" />
                  <p>2. 每一<a style="color: #ff0000">类</a>文件，都需要在系统中对应的参赛项目处相对应地上传，可以同时上传多个团队的文件。<p>
                  <p>3. 上传文件后，如需修改某个文件，请在此界面对应的队伍详情中删除文件、修改文件。<p>&ndash;&gt;
                    <div style="line-height: 30px;">
                       <div  style="border-bottom:1px solid #000">
                           <a href="../static/doc/学校批量上传操作手册.pdf"  target="_blank">若您不会操作，请查看此处操作演示</a>
                       </div>
                    </div>
                </el-col>
            </el-row>-->
            <el-row>
              <el-col :span="24" style="margin-top:15px">
                  <el-col :span="3" style="text-align:right">
                      参赛类型：
                  </el-col>
                  <el-col :span="20">
                    <el-radio-group v-model="uploadRadio">
                        <el-radio v-for="(item, index) in downloadWorkType" :key="index" :label="item.workTypeId" @change="uploadType">{{item.workTypeName}}</el-radio>
                    </el-radio-group>
                  <!--   <el-radio v-model="uploadRadio" label="53" @change="uploadType">创意作品-智慧社区大学组</el-radio>
                    <el-radio v-model="uploadRadio" label="55" @change="uploadType">创意作品-智慧社区中学组</el-radio>
                    <el-radio v-model="uploadRadio" label="54" @change="uploadType">科普实验-未来太空车</el-radio> -->
                  </el-col>
              </el-col>
              <el-col :span="24" style="margin-top:15px">
                  <el-col :span="3" style="text-align:right">
                    文件类型：
                  </el-col>
                  <el-col :span="20">
                    <el-radio-group v-model="fieldRadio">
                        <el-radio style="margin-bottom: 0;" v-for="(item, index) in fieldData" :key="index" :label="item.labelField" @change="getHint(item)">{{item.labelName}}</el-radio>
                    </el-radio-group>
                  </el-col>
              </el-col>
              <el-col :span="24"  style="margin-top:15px">
                <!-- <el-upload
                    class="upload-demo"
                    :action="uploadUrl"
                    :headers="headers"
                    :multiple="true"
                    :on-success="onSuccess"
                    :on-preview="onPreview"
                    :before-upload="beforeUpload"
                    :file-list="fileList"
                    list-type="picture">
                    <el-button size="small" type="primary" >点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">{{this.uploadWaring}}</div>
                </el-upload> -->
                <el-upload
                    class="upload-demo"
                    action="#"
                    :multiple="true"
                    :on-success="onSuccess"
                    :on-preview="onPreview"
                    :before-upload="beforeUpload"
                    :file-list="fileList"
                    list-type="picture"
                    :http-request="uploadFiles"
                    >
                    <el-button size="small" type="primary" >点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">{{this.uploadWaring}}</div>
                </el-upload>
              </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
        <el-dialog
         title="查看作品"
            :visible.sync="dialogWork"
            width="60%"
            :before-close="handleClose"
            :close-on-click-modal="false"
        >
         <el-button type="success" @click="editWork(undefined,true)" icon="el-icon-document-add"
                     style="background-color:#39C1C2;padding: 10px 15px;">作品申报
          </el-button>
             <div v-for="(item, index) in workList" :key="index">
                <div  class="work-item" style="margin:15px 0; text-align: center; background: #f0f0f0; border-radius: 5px">
                <el-row :gutter="10"  style="padding:15px 0">
                    <el-col :xs="24" :sm="6" :md="17" :lg="17" :xl="17">
                    <div>
                        <el-row :gutter="20" class="subText">
                        <el-col :lg="12" :xs="24">
                            <span>作品编号：{{ item.workDynamicData.id }}</span>
                        </el-col>
                        <el-col :lg="12" :xs="24">
                            <span>赛题组：{{ getTypeName(item.workDynamicData.categoryId) }}</span>
                        </el-col>
                        <el-col :lg="12" :xs="24">
                            <span>提交时间：{{ item.workDynamicData.createTime }}</span>
                        </el-col>
                        </el-row>
                    </div>
                    </el-col>
                    <el-col :xs="12" :sm="6" :md="4" :lg="4" :xl="4">
                    <el-button type="success" @click="editWork(item,false)"
                                style="background-color:#39C1C2;padding: 15px 15px" size="mini">查看详情
                    </el-button>
                    </el-col>
                </el-row>
                </div>
            </div>
            <div v-if="pageShow">
              <work-form
                    :temporary-falg="temporaryFalg"
                    :work-type-list="workTypeList"
                    @back="back"
                    :language="'cn'"
                    :disabled-falg="workEditFalg"
                    :form-type="workDetailForm.categoryId"
                    :form-obj="workDetailForm"
                    :site-id="this.siteId"
                    :division-id="workDetailForm.divisionId"
                    :teamUserId="teamUserId">
                </work-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import ChildLogo from '@/components/ChildLogo.vue'
import {getToken} from '@/utils/auth'
import {listBySiteIdSelectTearm, getDicts, getData, getParticipantData, getWorkDynamicField, getSignUpNunAndType} from '@/api/info/index'
import RegisterTearmComponents from '../views/my/form/registerTearmComponents'
import Pagination from './Pagination/index'
import {listData} from '@/api/work/workdata'
import {listWorksCategoryConf} from '@/api/work/worksCategoryConf'
import {conditionByParticipantDataByParams} from '@/api/registerForm'
import WorkForm from './workForm.vue'
import { uploadFile } from './../utils/BaiduBosUploader'
import { uploadFileSchool } from '@/api/system/file'

export default {
  components: {
    Pagination: Pagination,
    RegisterTearmComponents,
    ChildLogo: ChildLogo,
    WorkForm },
  data () {
    return {
      teamUserId: null,
      temporaryFalg: false,
      workTypeList: [],
      pageShow: false,
      workEditFalg: false,
      workList: [],
      maxSize: '',
      fileType: [],
      downloadWorkType: [],
      headers: { Authorization: 'Bearer ' + getToken() },
      uploadUrl: this.batchNormalUploadUrl,
      /** 文件列表 */
      storageList: [],
      fileList: [],
      uploadWaring: '',
      fieldRadio: '',
      fieldData: [],
      uploadRadio: '',
      radio: '',
      dialogWork: false,
      dialogVisible: false,
      divisionId: '',
      workDetailForm: {},
      disabledFalg: true,
      open: false,
      loading: false,
      teamField: [],
      form: {
        contParticipantMember: {},
        items: [{}],
        schoolSex: '0'
      },
      ruleRules: {},
      lablePosition: 'right',
      uploadStyle: '10.5% !important',
      dataList: [],
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        show: true,
        siteId: this.siteId,
        createBy: this.$store.state.user.userId
      },
      fieldNameOptions: [],
      fieldMap: {},
      dictDataList: [],
      language: 'cn',
      // remarkCopy:''
      uploadRemark: '',
      uploadFormType: ''
    }
  },
  beforeMount () {
    // 添加判断方法
    let mobile = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
    if (mobile) {
      this.lablePosition = 'top'
      this.uploadStyle = '25% !important'
    }
  },
  created () {
    this.getFileList()
    this.getSignUpType()
    /*  if(!this.remarkCopy){
            this.remarkCopy=this.labelField+Math.random()
            }
            this.uploadUrl=this.normalUploadUrl+this.remarkCopy */
    this.storageList = []
  },
  mounted () {
    this.getList()
    this.getWorkType()
  },
  methods: {
    async uploadFiles (params) {
      console.log('elupload', params)
      const progress = (e) => params.onProgress(e)
      try {
        const res = await uploadFile(params.file, progress)
        const data = {
          uid: params.file.uid,
          fileName: params.file.name,
          size: params.file.size,
          type: params.file.type,
          url: res.body.location,
          path: res.body.location,
          eTag: res.body.eTag,
          'x-bce-request-id': res.http_headers['x-bce-request-id'],
          remark: this.uploadRemark,
          formType: this.uploadFormType
        }

        // 对接业务
        uploadFileSchool(this.systemURL, data).then(res => {
          console.log('resschool123123', res)
          params.onSuccess(data)
        })
        this.$message.success('上传成功')
        console.log('baidu bos upload res', res)
      } catch (error) {
        console.log('baidu bos upload error', error)
        params.onError(error)
        this.$message.success('上传失败')
      }
    },
    // 获取赛题类型
    getTypeName (id) {
      let type = this.workTypeList.filter((type) => {
        return type.id == id
      })
      return type[0].name
    },
    getWorkType () {
      listWorksCategoryConf(this.baseURL, {
        siteId: this.siteId
      }).then(async res => {
        this.workTypeList = res.rows
      })
    },
    // 获取已报名类型的数据及数量
    getSignUpType () {
      let queryParams = {
        siteId: this.siteId,
        createBy: this.$store.state.user.userId
      }
      getSignUpNunAndType(this.baseURL, queryParams).then(res => {
        this.downloadWorkType = res.data
      })
    },
    // 文件上传成功的回调
    onSuccess (response, file, fileList) {
      if (!response) {
        return
      }
      this.storageList.push(response)
    },
    // 点击文件列表中已上传的文件时的钩子
    onPreview (file) {
      this.storageList.forEach(s => {
        if (s.fileName == file.name) {
          window.open(s.path)
        }
      })
    },
    // 添加文件前的回调
    beforeUpload (file) {
      // 移除超过上传大小的文件
      if (this.uploadRadio === '' || this.fieldRadio === '') {
        this.$message({
          message: '请选择参赛类型或附件所属字段',
          duration: 9000,
          type: 'warning'
        })
        return false
      }
      if (this.maxSize) {
        if (file.size > this.maxSize) {
          this.$message.error(file.name + (this.language === 'cn' ? '超出最大上传大小:' : 'Exceeding the maximum upload size') + this.maxSize + (this.language === 'cn' ? 'Bytes,请上传符合大小的文件' : 'Bytes,Please upload the appropriate file size'))
          this.uploadFalg = false
          return false
        }
      }
      let ary = file.name.split('.')
      if (!this.fileType || this.fileType.length === 0) {
        this.uploadFalg = true
      } else {
        if (this.fileType.indexOf(ary[ary.length - 1]) !== -1) {
          this.uploadFalg = true
        } else {
          let type = ''
          this.fileType.forEach((item, index) => {
            type += item + (index === (this.fileType.length - 1) ? '' : ',')
          })
          this.$message.error((this.language === 'cn' ? '只能上传[ ' : 'Must be uploaded[ ') + type + (this.language === 'cn' ? ' ]类型的文件' : ' ]file type'))
          this.uploadFalg = false
        }
      }
      return this.uploadFalg
    },
    getHint (obj) {
      this.uploadWaring = obj.remark
      console.log('obj')
      console.log(obj)
      this.fileType = JSON.parse(obj.fileType)
      this.maxSize = obj.fileSize
      this.uploadUrl = this.batchNormalUploadUrl + obj.labelField + '/' + obj.formType
      this.uploadRemark = obj.labelField
      this.uploadFormType = obj.formType
    },
    uploadType () {
      // 根据选择的类型的ID和站点ID获取不同的上传字段
      let queryParams = {
        siteId: this.siteId,
        formType: this.uploadRadio
      }
      getWorkDynamicField(this.baseURL, queryParams).then(res => {
        this.fieldData = res.data
      })
    },

    back () {
      this.pageShow = false
    },
    handleClose () {
      this.pageShow = false
      this.dialogWork = false
    },
    handleWorkDetail (row) {
      this.dialogWork = true
      // 给团队信息的userID赋值
      this.teamUserId = row.userId
      listData(this.siteURL, {
        siteId: this.siteId,
        userId: row.userId,
        status: 1
      }).then(res => {
        this.workList = []
        res.rows.forEach(row => {
          this.workList.push(row)
        })
      })
    },
    handleUpdate (row, type) {
      if (type === 'query') {
        this.disabledFalg = true
      } else {
        this.disabledFalg = false
      }
      const id = row.id || this.ids
      getData(this.baseURL, id).then(response => {
        let data = response.data.data
        this.form = JSON.parse(data)
        this.form.siteId = response.data.siteId
        this.form.userId = response.data.userId
        this.form.status = response.data.status
        this.form.id = response.data.id
        this.formLoading = true
        this.open = true
        this.title = '修改大赛单数据'
        var val = response.data.competitionProject
        console.log('val: ')
        console.log(val)
        console.log(typeof val)
        this.getFileListByMemberShow(val)
      })
    },

    handleAccount () {
      const link = document.createElement('a')
      this.axios
        .get(
          this.systemURL + '/user/getAccount/' + this.$store.state.user.userId,
          {
            responseType: 'arraybuffer',
            xsrfHeaderName: 'Authorization',
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + getToken()
            }
          }
        )
        .then((res) => {
          const blob = new Blob([res.data], {
            type: 'application/vnd.ms-excel'
          })
          const objectUrl = URL.createObjectURL(blob)
          link.href = objectUrl
          link.download = 'Participant account and password.xls' // 自定义文件名
          link.click() // 下载文件
          URL.revokeObjectURL(objectUrl)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 导出报名信息 ID 团队名称 用于批量提交作品
    exportSigUpInfo () {
      if (this.radio == '') {
        alert('请选择参赛项目后进行下载')
        return
      }
      const link = document.createElement('a')
      this.axios
        .get(
          this.baseURL + '/participantData/getSigUpInfo/' + this.$store.state.user.userId + '/' + this.radio,
          {
            responseType: 'arraybuffer',
            xsrfHeaderName: 'Authorization',
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + getToken()
            }
          }
        )
        .then((res) => {
          const blob = new Blob([res.data], {
            type: 'application/vnd.ms-excel'
          })
          const objectUrl = URL.createObjectURL(blob)
          link.href = objectUrl
          link.download = '团队报名信息.xls' // 自定义文件名
          link.click() // 下载文件
          URL.revokeObjectURL(objectUrl)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getList () {
      this.tableFalg = true
      this.dataWaitFalg = false
      this.loading = true
      this.queryParams.divisionId = this.divisionId
      getParticipantData(this.baseURL, this.queryParams).then((response) => {
        this.dataList = []
        let dictFields = this.teamField.filter((field) => {
          return field.label_field
        })
        response.rows.forEach((item) => {
          let obj = {}
          obj = item
          obj.data = JSON.parse(item.data)
          this.dataList.push(obj)
        })
        this.total = response.total
        this.loading = false
        this.dataWaitFalg = true
      })
    },
    getFileListByMemberShow (val) {
      return new Promise((resolve, reject) => {
        if (val === '2' || val === 2) {
          this.queryParams.dynamicDisplay = '0'
        } else if (val === '3' || val === 3) {
          this.queryParams.dynamicDisplay = '1'
        } else if (val === '1' || val === 1) {
          this.queryParams.dynamicDisplay = '2'
        }
        listBySiteIdSelectTearm(this.baseURL, this.queryParams).then(res => {
          this.fieldMap = res.data.fieldMap
          this.dictDataList = res.data.dictDataList
          this.fieldNameOptions = res.data.fieldNameOptions
          resolve()
        })
      })
    },
    getFileList () {
      return new Promise((resolve, reject) => {
        listBySiteIdSelectTearm(this.baseURL, this.queryParams).then(res => {
          this.fieldMap = res.data.fieldMap
          this.dictDataList = res.data.dictDataList
          this.fieldNameOptions = res.data.fieldNameOptions
          if (this.fieldNameOptions.length === 0) {
            this.tableFalg = false
            this.$message({
              message: '此站点尚未配置' + (this.queryParams.status === '0' ? '个人' : '团队') + '报名表单信息',
              type: 'info',
              duration: 1000
            })
          } else {
            this.fieldNameOptions.forEach((item, index) => {
              if (item.type) {
                // 此处是为了判断多个字段用一个字典重复查询
                if (!this.interpretObj[item.type]) {
                  getDicts(this.systemURL, item.type).then(res => {
                    this.interpretObj[item.type] = res.data
                  })
                }
              }
            })
          }
          resolve()
        })
      })
    },
    editWork (item, temporaryFalg) {
      let user = null
      if (item == undefined) {
        user = this.teamUserId
      } else {
        user = item.workDynamicData.userId
      }
      this.pageShow = false
      this.workDetailForm = {}
      conditionByParticipantDataByParams(this.baseURL, {
        siteId: this.siteId,
        userId: user,
        status: 1
      }).then(res => {
        if (res.data.length == 0) {
          this.$alert('请先报名参赛！', '提示', {
            confirmButtonText: '确定',
            type: 'warning',
            showClose: false
          }).then(() => {
            this.$router.push({
              path: '/preliminaryApply'
            })
          }).catch(() => {
          })
        } else {
          if (item) {
            let work = {...item.workDynamicData}
            let editFalg = true
            if (item.nodeList) {
              item.nodeList.forEach(node => {
                if (node.nodeType == 'file-check') {
                  editFalg = false
                }
              })
            }
            this.workEditFalg = false
            this.temporaryFalg = false
            let workForm = JSON.parse(work.data)
            workForm.siteId = work.siteId
            workForm.userId = work.userId
            workForm.id = work.id
            workForm.divisionId = work.divisionId
            workForm.categoryId = work.categoryId
            workForm.participantId = res.data[0].id
            workForm.competitionProject = res.data[0].competitionProject
            this.workDetailForm = workForm
            this.pageShow = true
          } else {
            this.workEditFalg = false
            this.temporaryFalg = true
            this.workDetailForm.categoryId = this.workTypeList[0].id
            this.workDetailForm.participantId = res.data[0].id
            this.pageShow = true
            this.workDetailForm.divisionId = res.data[0].divisionId
          }
        }
      })
    }
  }
}
</script>

<style scoped>
    .expertName {
        display: inline-block;
        text-align: left;
        width: 50%;
        color: #0654ef;
        font-size: 36px;
        padding-left: 20px;
    }

    .introduction {
        text-align: left;
        padding: 20px;
        text-indent: 2em;
    }

    .sigma-content {
        margin: 40px 0 10px;
        text-align: center;
        background-color: #fff;
    }

    .sigma-middle-line:before {
        content: "";
        display: block;
        height: 1px;
        width: 100%;
        background-color: #0654ef; /*颜色需与bai主题大背景du色一致zhi*/
        position: relative;
        top: 25px; /*调节线高*/
        left: 0;
    }

    .sigma-line-text {
        display: inline-block;
        background: #fff;
        padding: 0 18px 0 18px;
        position: relative;
        font-size: 28px;
        font-weight: 500;
        color: #0654ef;
    }

    .firstLevel {
        text-align: left;
        font-weight: bold;
    }

    .raceIntroduction .el-form-item__content > div {
        width: 100%;
    }

    /* .el-form-item__content .el-button--primary {
      width: 25% !important;
    } */
</style>



// WEBPACK FOOTER //
// src/components/CompusHomeUp.vue